// pages/Home.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { apiGet } from '../api/client';

import CollageSection from '../components/Collage';

import samirdutta from '../images/samirdutta.png';

const Home = () => {

    const [testimonials, setTestimonials] = useState([]);
    const [currentTestimonial, setCurrentTestimonial] = useState(0);

    useEffect(() => {
        const loadTestimonials = async () => {
            try {
                const data = await apiGet('/testimonials');
                setTestimonials(data.map((item) => ({
                    id: item.id,
                    text: item.text,
                    author: item.location ? `${item.name}, ${item.location}` : item.name
                })));
            } catch (err) {
                setTestimonials([]);
            }
        };

        loadTestimonials();
    }, []);

    useEffect(() => {
        if (testimonials.length === 0) return;
        const interval = setInterval(() => {
            setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
        }, 5000);
        return () => clearInterval(interval);
    }, [testimonials.length]);

    // Extract first paragraph of biography for preview
    const biographyPreview = "Eminent Artist Samir Dutta hailing from North Indian ambience and trained from rich culture heritage of Chhattisgarh uses Folk backdrop as a sophisticated artistic tool in his art. In this way he is a pioneer in inducing modernism in elements of folk tradition. Samir not only derives artistic inspiration from folk, but also plunges deep inside of the inner world.";

    return (
        <div>
            {/* Hero Section */}
            <section className="hero" style={{ minHeight: 'calc(100vh - 60px)' }}>
                <CollageSection />
            </section>

            {/* Featured Exhibition Section */}
            <div className="section" style={{ textAlign: 'center', padding: '2rem 0 1rem' }}>
                <div style={{
                    display: 'inline-block',
                    padding: '0.5rem 1.5rem',
                    backgroundColor: 'var(--primary-color)',
                    color: 'white',
                    borderRadius: '4px',
                    fontSize: '1.1rem',
                    boxShadow: '0 3px 6px rgba(0,0,0,0.1)'
                }}>
                    <span style={{ fontWeight: 'bold' }}>Latest Exhibition:</span> "MYTHOLOGY" - The Stadel Hotel, Kolkata 2023
                </div>
            </div>

            {/* Biography Highlight Section */}
            <section id="about" className="section">
                <div className="container">
                    <h2 className="section-title slide-up">Artist's Journey</h2>
                    <div className="about-preview">
                        <div className="about-preview-text slide-up">
                            <p style={{ fontSize: '1.1rem', fontStyle: 'italic', marginBottom: '1.5rem', borderLeft: `3px solid var(--primary-color)`, paddingLeft: '1rem' }}>
                                {biographyPreview}
                            </p>
                            <p>
                                After this plunge he engulfs modernism at many strata of folk tradition. In a way he, by placing folk practice on modern society's mirror, makes it a part of chemistry. In this chemistry he weighs tradition from many angles and places it before the modern world.
                            </p>
                            <Link to="/about" className="btn" style={{ marginTop: '1.5rem' }}>
                                Read Full Biography
                            </Link>
                        </div>
                        <div className="about-preview-image slide-up">
                            <img src={samirdutta} alt="Samir Dutta" />
                        </div>
                    </div>
                </div>
            </section>

            {/* Awards Section */}
            < section id="awards" className="section" style={{ backgroundColor: 'rgba(227, 180, 72, 0.05)', padding: '4rem 0' }}>
                <div className="container">
                    <h2 className="section-title">Awards & Recognition</h2>
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
                        gap: '2rem',
                        marginTop: '3rem'
                    }}>
                        <div className="award-item slide-up" style={{
                            backgroundColor: 'white',
                            padding: '1.5rem',
                            borderRadius: '8px',
                            boxShadow: '0 5px 15px rgba(0, 0, 0, 0.05)',
                            textAlign: 'center',
                            border: '1px solid rgba(227, 180, 72, 0.3)'
                        }}>
                            <div style={{ marginBottom: '1rem' }}>
                                <i className="fas fa-award" style={{ fontSize: '2.5rem', color: 'var(--secondary-color)' }}></i>
                            </div>
                            <h4>LIVIN ART International Exhibition</h4>
                            <p>"Best Achievement Award"</p>
                            <p style={{ color: 'var(--accent-color)', marginTop: '0.5rem' }}>Bangladesh, 2023</p>
                        </div>

                        <div className="award-item slide-up" style={{
                            backgroundColor: 'white',
                            padding: '1.5rem',
                            borderRadius: '8px',
                            boxShadow: '0 5px 15px rgba(0, 0, 0, 0.05)',
                            textAlign: 'center',
                            border: '1px solid rgba(227, 180, 72, 0.3)'
                        }}>
                            <div style={{ marginBottom: '1rem' }}>
                                <i className="fas fa-medal" style={{ fontSize: '2.5rem', color: 'var(--secondary-color)' }}></i>
                            </div>
                            <h4>FOCUS BANGLA International Exhibition</h4>
                            <p>"Excellent Award"</p>
                            <p style={{ color: 'var(--accent-color)', marginTop: '0.5rem' }}>Bangladesh, 2023</p>
                        </div>

                        <div className="award-item slide-up" style={{
                            backgroundColor: 'white',
                            padding: '1.5rem',
                            borderRadius: '8px',
                            boxShadow: '0 5px 15px rgba(0, 0, 0, 0.05)',
                            textAlign: 'center',
                            border: '1px solid rgba(227, 180, 72, 0.3)'
                        }}>
                            <div style={{ marginBottom: '1rem' }}>
                                <i className="fas fa-trophy" style={{ fontSize: '2.5rem', color: 'var(--secondary-color)' }}></i>
                            </div>
                            <h4>RABINDRA SAMMAN</h4>
                            <p>Artistic Excellence</p>
                            <p style={{ color: 'var(--accent-color)', marginTop: '0.5rem' }}>2016</p>
                        </div>
                    </div>

                    <div style={{ textAlign: 'center', marginTop: '2rem' }}>
                        <Link to="/cv" className="btn" style={{ background: 'transparent', color: 'var(--primary-color)', border: '1px solid var(--primary-color)' }}>
                            View All Awards
                        </Link>
                    </div>
                </div>
            </section >

            {/* Artistic Philosophy Section */}
            < section id="philosophy" className="section" >
                <div className="container">
                    <h2 className="section-title">Artistic Philosophy</h2>
                    <div className="philosophy-content" style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
                        <div className="bengali-pattern pattern-top"></div>
                        <p style={{ fontSize: '1.2rem', lineHeight: 1.8, margin: '2rem 0' }}>
                            "Most appealing quality of Samir's paintings is their narrative base. It looks as though he is telling a story in each of his painting. Some time this tale is inherently interspersed between his painting and sometimes it hangs behind. It is mythological and modern as well. Its innate base lies somewhere in the folk."
                        </p>
                        <div className="bengali-pattern pattern-bottom"></div>
                    </div>
                </div>
            </section >

            {/* Testimonials Section */}
            {testimonials.length > 0 && (
                <section id="testimonials" className="testimonials">
                    <div className="container">
                        <h2 className="section-title">What Critics Say</h2>
                        <div className="testimonial-slider">
                            <div className="testimonial-item fade-in">
                                <p>"{testimonials[currentTestimonial].text}"</p>
                                <p className="testimonial-author">- {testimonials[currentTestimonial].author}</p>
                            </div>
                        </div>
                    </div>
                </section>
            )}

            {/* Contact CTA Section */}
            < section className="contact-cta" >
                <div className="container">
                    <div className="contact-cta-content">
                        <h2 className="section-title">Connect With The Artist</h2>
                        <p>
                            Interested in commissioning a piece, exhibiting works, or discussing the intersection of folk tradition and modern art? Reach out to begin a conversation.
                        </p>
                        <Link to="/contact" className="btn">
                            Get In Touch
                        </Link>
                    </div>
                </div>
            </section >
        </div >
    );
};

export default Home;